import React from 'react';
import {
  GuangzhouEvergrande, 
  BeijingGuoan, 
  ShandongTaishan, 
  ShanghaiPort,
  JiangsuSuning,
  ChangchunYatai,
  ShenzhenJianlibao,
  DalianShide,
  WuhanThreeTowns 
} from "../clubs";


const Csl = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won Chinese Super League (CSL).</h1>
      <ShanghaiPort />
      <WuhanThreeTowns />
      <ShandongTaishan />
      <JiangsuSuning />
      <GuangzhouEvergrande />
      <BeijingGuoan />
      <ChangchunYatai />
      <DalianShide />
      <ShenzhenJianlibao />
      
    </div>
  )
}

export default Csl